import { useEffect, useState } from 'react';

import { getHasActiveChat } from '../services/dataProvider';
import { SUPPORT_CHAT_EVENTS } from '../constants';

function useSupportChatVisibility(): boolean {
    const [isVisible, setIsVisible] = useState(getHasActiveChat() === 'yes');

    useEffect(() => {
        function chatVisibilityListener(event: Event): void {
            if (event instanceof CustomEvent) {
                setIsVisible(event.detail);
            }
        }

        window.addEventListener(
            SUPPORT_CHAT_EVENTS.SUPPORT_CHAT_VISIBILITY,
            chatVisibilityListener
        );

        return () => {
            window.removeEventListener(
                SUPPORT_CHAT_EVENTS.SUPPORT_CHAT_VISIBILITY,
                chatVisibilityListener
            );
        };
    }, []);

    return isVisible;
}

export { useSupportChatVisibility };
